import { HttpRequest } from "@angular/common/http";
import { ReportComment } from "@partikelart/portal/shared-typing";

export function saveCommentToLocalStorage(request: HttpRequest<any>) {
	const form = request.body as FormData;
	localStorage.setItem(`comment/${form.get("analysis_no")}`, form.get("comment_text") as string);
}

export function getCommentFromLocalStorage(analysisNo: string): ReportComment {
	const reportComment = new ReportComment();
	reportComment.CommentText = localStorage.getItem(`comment/${analysisNo}`);
	reportComment.AnalysisNo = analysisNo;
	return reportComment;
}

export function deleteReportComment(analysisNo: string): void {
	localStorage.removeItem(`comment/${analysisNo}`);
	return;
}
